import React, { useState } from 'react';
import { Card, Table, Button } from 'react-bootstrap';
;

const  InfoEquipe = ({ team, equipe }) => {
    const [showClassement, setShowClassement] = useState(true);
    const [showMatches, setShowMatches] = useState(false);

  
    return (
      <Card className="mb-3">
        <Card.Header>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h5>{team.nom}</h5>
            <div>
              <Button variant="link" className="custom-link-button" onClick={()=> {setShowClassement(true);setShowMatches(false)}}>Classement</Button>
              <Button variant="link" className="custom-link-button" onClick={()=> {setShowClassement(false);setShowMatches(true)}}>Matchs</Button>
            </div>
          </div>
          {showClassement && (
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Rang</th>
                        <th>Team</th>
                        <th>M</th>
                        <th>V</th>
                        <th>N</th>
                        <th>D</th>
                        <th>Buts</th>
                        <th>+/-</th>
                        <th>Points</th>
                      </tr>
                    </thead>
                    {equipe.classement
                        .filter(classement => classement.id_equipe === team.id_equipe)
                        .map((item, index) => (
                    <tbody key={index}>
                              <tr >
                                 <td className="rank">{item.position}</td>
                                 <td className="team">{item.nom}</td>
                                 <td className="matchs">{item.matchs}</td>
                                 <td className="win">{item.victoires}</td>
                                 <td className="match_nul">{item.nul}</td>
                                 <td className="loose">{item.défaites}</td>
                                 <td className="buts">{item.buts}</td>
                                 <td className="diff">{item.différence}</td>
                                 <td className="points">{item.points}</td>
                              </tr>
                        </tbody>
              ))}
            </Table>
            </div>
          )}
        </Card.Header>
        <Card.Body>
          {showMatches && (
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Match</th>
                    <th>Résultat</th>
                  </tr>
                </thead>
                <tbody>
                  {equipe.match
                    .filter(match => match.id_equipe === team.id_equipe)
                    .map((match, index) => (
                      <tr key={index}>
                        <td>{match.date}</td>
                        <td>{match.equipe_dom} - {match.equipe_ext}</td>
                        <td>{match.score}</td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          )}
        </Card.Body>
      </Card>
    );
  };


export default InfoEquipe;